import { AlertService } from './../../shared/services/alert.service';
import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { Observable } from 'rxjs/internal/Observable';
import * as fromActions from './holiday.actions';
import { catchError, map, mergeMap, switchMap, exhaustMap } from 'rxjs/operators';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { HolidayAdapter } from './holiday.adapter';
import { of } from 'rxjs/internal/observable/of';
import { DealershipHolidaysService } from '../../dealership-holidays/dealership-holidays.service';
import { IHoliday, IHolidaysResponse, IHolidayResponse } from '@signal/asp-data-commons';


@Injectable()
export class HolidayEffects {
  somethingWentWrongPleaseTryAgain =  'otherTexts.somethingWentWrongPleaseTryAgain';

  constructor(
    private actions$: Actions,
    private holidayService: DealershipHolidaysService,
    private alertService: AlertService
  ) {
  }

  
  loadHolidays: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType<fromActions.LoadHolidays>(
      fromActions.HolidayActionTypes.LOAD_HOLIDAYS
    ),
    mergeMap((action: fromActions.LoadHolidays) =>
      this.holidayService.getHolidays(action.payload.department).pipe(
        switchMap((holidays: IHolidaysResponse) => HolidayAdapter.toHolidays(holidays)),
        map((holidays: IHoliday[]) => new fromActions.LoadHolidaysSuccess({ holidays })),
        catchError(err => of(new fromActions.LoadHolidaysFail({ error: err })))
      )
    )
  ));

  
  createHoliday: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType<fromActions.CreateHoliday>(
      fromActions.HolidayActionTypes.CREATE_HOLIDAY
    ),
    mergeMap((action: fromActions.CreateHoliday) =>
      this.holidayService.createHoliday(action.payload.department, action.payload.holiday).pipe(
        switchMap((holidayResponse: IHolidayResponse) => HolidayAdapter.toHoliday(holidayResponse)),
        map(
          (newHoliday: IHoliday) => {
            this.alertService.showAlert('otherTexts.holidayCreatedSuccessfully', '', '', 5000, false);
            return new fromActions.CreateHolidaySuccess(newHoliday)
          }
        ),
        catchError(err => {
          this.alertService.showAlert(this.somethingWentWrongPleaseTryAgain);
          return of(new fromActions.CreateHolidayFail(err))
        })
      )
    )
  ));

  
  updateHoliday: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType<fromActions.UpdateHoliday>(
      fromActions.HolidayActionTypes.UPDATE_HOLIDAY
    ),
    mergeMap((action: fromActions.UpdateHoliday) =>
      this.holidayService.updateHoliday(action.payload.department, action.payload.holiday.holidayId, action.payload.holiday).pipe(
        switchMap((holidayResponse: IHolidayResponse) => HolidayAdapter.toHoliday(holidayResponse)),
        map(
          (updateHoliday: IHoliday) => {
            this.alertService.showAlert('otherTexts.holidayUpdatedSuccessfully', '', '', 5000, false);
            return new fromActions.UpdateHolidaySuccess(updateHoliday)
          }
        ),
        catchError(err => {
          this.alertService.showAlert(this.somethingWentWrongPleaseTryAgain);
          return of(new fromActions.UpdateHolidayFail(err))
        })
      )
    )
  ));

  
  deleteHoliday: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType<fromActions.DeleteHoliday>(
      fromActions.HolidayActionTypes.DELETE_HOLIDAY
    ),
    mergeMap((action: fromActions.DeleteHoliday) =>
      this.holidayService.deleteHoliday(action.payload.department, action.payload.holidayId).pipe(
        map(() => {
          this.alertService.showAlert('otherTexts.holidayDeletedSuccessfully', '', '', 5000, false);
          return new fromActions.DeleteHolidaySuccess(action.payload.holidayId)
        }),
        catchError(err => {
          this.alertService.showAlert(this.somethingWentWrongPleaseTryAgain);
          return of(new fromActions.DeleteHolidayFail(err))
        })
      )
    )
  ));

}
